import React from 'react';
import style from '../PopupsCommonStyle.module.css';
import s from './CreateProductCatalog.module.css';
import {Form, Formik, FormikHelpers} from 'formik';
import LightGreenButton from '../../../../Components/Buttons/LightGreenButton';
import GreenButton from '../../../../Components/Buttons/GreenButton';
import DeferredOrdersForm from './DeferredOrdersForm';
import CommonSvgSelector from '../../../../assets/common/SVG/CommonSvgSelector';
import {useSaveDeferredMutation} from '../../../../redux/userOrdersApi';
import {formatNumber, handleApiCall} from '../../../../assets/utils/utils';
import {validateCreateDeferred} from '../../../../assets/utils/validation';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

const PopupCreateProductCatalog = ({
	close,
	balance,
	onSaveSuccess,
}: {
	close: () => void;
	balance: string;
	onSaveSuccess?: () => void;
}) => {
	const [saveDeferred] = useSaveDeferredMutation();
	const {t} = useTranslation();

	const removeComponent = (index: number, setFieldValue: any, values: any) => {
		const updatedComponents = values.orders.filter(
			(_: any, i: number) => i !== index,
		);
		setFieldValue('orders', updatedComponents);
	};

	const initialValues = {
		orders: [
			{
				user_id: '', //ідентифікатор обраного клієнта
				points: '', //бали для оформлення
			},
		],
	};
	type InitialValuesType = typeof initialValues;
	const handleSubmit = async (
		values: InitialValuesType,
		{resetForm}: FormikHelpers<InitialValuesType>,
	) => {
		const createData = values.orders.map((el) => ({
			user_id: +el.user_id,
			points: +el.points,
		}));
		await handleApiCall({
			apiCall: () => saveDeferred({orders: createData}),
			onSuccess: (data) => {
				resetForm();
				toast.success(data.message.textmsg);
				// Закрываем попап
				close();
				// Вызываем callback для скролла и обновления таблицы
				if (onSaveSuccess) {
					onSaveSuccess();
				}
			},
		});
	};
	return (
		<div className={style.wrapper}>
			<Formik
				initialValues={initialValues}
				validationSchema={validateCreateDeferred(+balance)}
				onSubmit={handleSubmit}
			>
				{({values, setFieldValue}) => (
					<Form className={`${style.container} ${s.container}`}>
						<div className={s.closeCrossContainer}>
							<button onClick={close} type={'button'}>
								<CommonSvgSelector id={'closeCross'} />
							</button>
						</div>
						<div className={s.title}>
							{t('Оформити відкладені бали')}
							{/*{t('Оформити відкладені замовлення')}*/}
							{/*Создание отложенного заказа*/}
						</div>
						<div className="user-deferred__sum">
							{formatNumber(balance)}
							<span>{t('Балів')}</span>
						</div>
						<div className="user-deferred__info">
							{t('Доступні бали для оформлення')}
						</div>
						{values.orders.map((_, index: number) => (
							<div key={index}>
								<DeferredOrdersForm index={index} />
								{index > 0 && (
									<div className={s.deleteButton}>
										<GreenButton
											type={'button'}
											onClick={() =>
												removeComponent(index, setFieldValue, values)
											}
											text={'Видалити'}
										/>
									</div>
								)}
							</div>
						))}

						<div className={s.buttons}>
							<LightGreenButton type={'submit'} text={'Зберегти оформлення'} />
							<GreenButton
								type={'button'}
								onClick={() => {
									const newOrder = {user_id: '', points: ''};
									setFieldValue(`orders`, [...values.orders, newOrder]);
								}}
								text={'Додати оформлення'}
							/>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default PopupCreateProductCatalog;
